import Box from "@mui/material/Box";
import { SxProps, useTheme } from "@mui/material/styles";
import { memo } from "react";

import { Logo } from "components/Logo/Logo";
import { VERTICAL_APP_BAR_WIDTH } from "constants/layout";
import { organizationByAppTheme } from "constants/theming";
import { useAppTheme } from "contexts/useAppThemeContext";
import { useNavigation } from "hooks/useNavigation";
import { AppTheme } from "typings/AppTheme";

const useSxProps = ({
  sizeMultiplier,
}: {
  sizeMultiplier: number;
}): SxProps => {
  const theme = useTheme();

  const { appTheme } = useAppTheme();

  switch (appTheme) {
    case AppTheme.ACME:
      return {
        height: theme.spacing(3 * sizeMultiplier),
        width: theme.spacing(10 * sizeMultiplier),
      };
    case AppTheme.ASCARI_LIGHT:
      return {
        height: theme.spacing(3 * sizeMultiplier),
        width: theme.spacing(VERTICAL_APP_BAR_WIDTH - 15.5 * sizeMultiplier),
      };
    case AppTheme.BI_DARK:
      return {
        height: theme.spacing(3 * sizeMultiplier),
        width: theme.spacing(VERTICAL_APP_BAR_WIDTH - 10 * sizeMultiplier),
      };
    case AppTheme.CURATED_LIGHT:
      return {
        width: theme.spacing(VERTICAL_APP_BAR_WIDTH - 10 * sizeMultiplier),
      };
    case AppTheme.DRIVEN_DARK:
    case AppTheme.DRIVEN_LIGHT:
      return {
        height: theme.spacing(3 * sizeMultiplier),
        width: theme.spacing(15 * sizeMultiplier),
      };
    case AppTheme.ILR_DARK:
      return {
        width: theme.spacing(6 * sizeMultiplier),
      };
    case AppTheme.KESSEL_DARK:
      return { width: VERTICAL_APP_BAR_WIDTH - 15 * sizeMultiplier };
  }
};

type BrandProps = {
  disableClick?: boolean;
  sizeMultiplier?: number;
};

export const Brand = memo(function Brand({
  disableClick = false,
  sizeMultiplier = 1,
}: BrandProps) {
  const { goToRoot } = useNavigation();
  const { appTheme } = useAppTheme();

  const sxProps = useSxProps({ sizeMultiplier });

  return (
    <Box
      onClick={disableClick ? undefined : goToRoot}
      sx={{
        cursor: disableClick ? "default" : "pointer",
        display: "flex",
        ...sxProps,
      }}
    >
      <Logo organizationId={organizationByAppTheme[appTheme]} />
    </Box>
  );
});
